import React from 'react';

import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ArticleCard = ({ article, featured = false }) => {
  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getReadingTime = (content) => {
    const wordsPerMinute = 200;
    const wordCount = content?.split(' ')?.length;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  if (featured) {
    return (
      <div className="relative group overflow-hidden rounded-brand bg-card border border-border hover-lift transition-brand">
        <div className="aspect-video overflow-hidden">
          <Image
            src={article?.image}
            alt={article?.imageAlt}
            className="w-full h-full object-cover group-hover:scale-105 transition-brand"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <div className="flex items-center space-x-4 mb-3">
            <span className="px-3 py-1 bg-primary rounded-full text-xs font-medium">
              {article?.category}
            </span>
            <span className="text-sm opacity-90">{formatDate(article?.publishedAt)}</span>
          </div>
          
          <h2 className="text-2xl font-bold mb-2 line-clamp-2">
            {article?.title}
          </h2>
          
          <p className="text-sm opacity-90 mb-4 line-clamp-2">
            {article?.excerpt}
          </p>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <Image
                src={article?.author?.avatar}
                alt={article?.author?.avatarAlt}
                className="w-8 h-8 rounded-full"
              />
              <div>
                <p className="text-sm font-medium">{article?.author?.name}</p>
                <p className="text-xs opacity-75">{article?.author?.role}</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4 text-xs opacity-75">
              <span className="flex items-center space-x-1">
                <Icon name="Clock" size={12} />
                <span>{getReadingTime(article?.content)} min read</span>
              </span>
              <span className="flex items-center space-x-1">
                <Icon name="Eye" size={12} />
                <span>{article?.views}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="group bg-card border border-border rounded-brand overflow-hidden hover-lift transition-brand">
      <div className="aspect-video overflow-hidden">
        <Image
          src={article?.image}
          alt={article?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-brand"
        />
      </div>
      <div className="p-6">
        <div className="flex items-center space-x-4 mb-3">
          <span className="px-3 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium">
            {article?.category}
          </span>
          <span className="text-sm text-muted-foreground">{formatDate(article?.publishedAt)}</span>
        </div>
        
        <h3 className="text-lg font-semibold mb-2 line-clamp-2 group-hover:text-primary transition-brand">
          {article?.title}
        </h3>
        
        <p className="text-muted-foreground text-sm mb-4 line-clamp-3">
          {article?.excerpt}
        </p>
        
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Image
              src={article?.author?.avatar}
              alt={article?.author?.avatarAlt}
              className="w-8 h-8 rounded-full"
            />
            <div>
              <p className="text-sm font-medium">{article?.author?.name}</p>
              <p className="text-xs text-muted-foreground">{article?.author?.role}</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-4 text-xs text-muted-foreground">
            <span className="flex items-center space-x-1">
              <Icon name="Clock" size={12} />
              <span>{getReadingTime(article?.content)} min read</span>
            </span>
            <span className="flex items-center space-x-1">
              <Icon name="Eye" size={12} />
              <span>{article?.views}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;